import "./App.css";
import { useEffect, useState } from "react";

import OTPButton from "./components/request-otp/requestotp";

const App = () => {
  const [fontFamily, setFontFamily] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [cartValue, setCartValue] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setCartValue(searchParams.get("cart"));
    const font = searchParams.get("font") || "Roboto";
    setFontFamily(font);
    setPrimaryColor(searchParams.get("primaryColor") || "#674399");
    setSecondaryColor(searchParams.get("secondaryColor") || "#eeeaf4");

    // Load the Google Font dynamically
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${font.replace(/\s+/g, '+')}:wght@${"400;700"}&display=swap`;
    document.head.appendChild(link);

    // Send initial height to parent
    const sendHeight = () => {
      window.parent.postMessage({ type: "SET_IFRAME_HEIGHT", height: document.body.scrollHeight + 60 }, "*");
    };

    // Adjust height on load and on resize
    sendHeight();

    // Observe changes to dynamically adjust height
    const observer = new MutationObserver(() => {
      sendHeight();
    });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };

  }, []);

  // Set CSS variables for dynamic theming
  useEffect(() => {
    document.documentElement.style.setProperty("--primary-color", primaryColor);
    document.documentElement.style.setProperty("--secondary-color", secondaryColor);
    document.documentElement.style.setProperty("--font-family", fontFamily);
  }, [fontFamily, primaryColor, secondaryColor]);

  return (
    <div>
      <br />
      <div className="app-container">
        <OTPButton cartValue={cartValue} />
      </div>
    </div>
  );
};

export default App;
